import React from 'react'
import WariantLicencji from './WariantLicencji'
import { ZakupLicencjiWariantStyle } from '../../styles/ZakupLicencjiStyle'
import { faPhoneSquare } from '@fortawesome/pro-light-svg-icons'

export default function ZakupLicencjiWariant({ onSelect }) {
  return (
    <ZakupLicencjiWariantStyle>
      <div className="medium-headline-5 header">
        Wybierz wariant licencji najlepiej pasujący do Twoich potrzeb
      </div>
      <div className="wariantList">
        <WariantLicencji
          label="Firma"
          description="Licencja pozwala na przygotowanie pliku XML z e-Sprawozdaniem dla jednego podmiotu i obejmuje następujące struktury:"
          price={910.0}
          structures={[
            { symbol: 'IN', name: 'Jednostka INNA' },
            { symbol: 'MA', name: 'Jednostka MAŁA' },
            { symbol: 'MI', name: 'Jednostka MIKRO' },
            { symbol: 'OP', name: 'Organizacja pozarządowa' },
          ]}
          canSelect={true}
          onSelect={onSelect}
        />
        <WariantLicencji
          label="Biuro rachunkowe"
          description="Licencja pozwala na przygotowanie plikiów XML z e-Sprawozdaniami dla dowolnej liczby podmiotów i obejmuje następujące struktury:"
          price={1490.0}
          structures={[
            { symbol: 'IN', name: 'Jednostka INNA' },
            { symbol: 'MA', name: 'Jednostka MAŁA' },
            { symbol: 'MI', name: 'Jednostka MIKRO' },
            { symbol: 'OP', name: 'Organizacja pozarządowa' },
          ]}
          canSelect={true}
          onSelect={onSelect}
        />
        <WariantLicencji
          label="Licencja Premium"
          description="Licencja pozwala na przygotowanie plików XML z e-Sprawozdaniami dla dowolnej liczby podmiotów i obejmuje następujące struktury:"
          img={faPhoneSquare}
          structures={[
            { symbol: 'IN', name: 'Jednostka INNA' },
            { symbol: 'MA', name: 'Jednostka MAŁA' },
            { symbol: 'MI', name: 'Jednostka MIKRO' },
            { symbol: 'OP', name: 'Organizacja pozarządowa' },
            { symbol: 'DM', name: 'Dom maklerski' },
            { symbol: 'SIN', name: 'Skonsolidowana jednostka INNA' },
            // { symbol: 'ZU', name: 'Zakłady ubezpieczeń i reasekuracji' },
          ]}
        />
      </div>
    </ZakupLicencjiWariantStyle>
  )
}
